import { MoboOutletDisclaimersCopyUrl, MoboOutletDisclaimersUrl, MoboOutletDisclaimersWithIdUrl, MoboOutletDisclaimersWithOutletIdUrl } from "../../../../../constants/apiUrls";
import { DisplayMessage } from "../../../../../services/helpers";
import { DeleteRequest, GetRequest, UpdateRequest } from "../../../../../services/requestHelpers";
import { HttpMethods } from "../../../../../utils/constants";

export const getDisclaimers = async (moboOutletId) => {
  const response = await GetRequest(MoboOutletDisclaimersWithOutletIdUrl(moboOutletId));
  var result = await response.json();
  if (!response.ok) {
    for (var i = 0; i < result.errors.length; i++) {
      DisplayMessage(result.errors[i], "error");
    }
    return undefined;
  }
  return result;
}

export const copyDisclaimer = async (data) => {
  const response = await UpdateRequest(MoboOutletDisclaimersCopyUrl(), data, HttpMethods.Post);
  var result = await response.json();
  if (!response.ok) {
    for (var i = 0; i < result.errors.length; i++) {
      DisplayMessage(result.errors[i], "error");
    }
    return undefined;
  }
  return result;
}

export const deleteDisclaimer = async (id) => {
  const response = await DeleteRequest(MoboOutletDisclaimersWithIdUrl(id));

  if (!response.ok) {
    response.json().then(result => {
      for (var i = 0; i < result.errors.length; i++) {
        DisplayMessage(result.errors[i], "error");
      }
    });
  }

  return response.ok;
}

export const createDisclaimer = async (data) => {
  const response = await UpdateRequest(MoboOutletDisclaimersUrl(), data, HttpMethods.Post);
  var result = await response.json();
  if (!response.ok) {
    for (var i = 0; i < result.errors.length; i++) {
      DisplayMessage(result.errors[i], "error");
    }
    return undefined;
  }
  return result;
}